import { toast, type Id, type ToastOptions } from 'react-toastify';

import { translateApiMessage } from '@/utils/translateApiMessage';

const shared: ToastOptions = {
  hideProgressBar: true,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  closeOnClick: true,
  draggable: false,
};

const DISMISS_BUFFER_MS = 500;

function scheduleDismiss(id: Id, autoCloseMs: number | false | undefined) {
  if (typeof autoCloseMs !== 'number' || autoCloseMs <= 0) return;
  window.setTimeout(() => {
    toast.dismiss(id);
  }, autoCloseMs + DISMISS_BUFFER_MS);
}

function showToast(
  type: 'success' | 'error' | 'warn' | 'info',
  message: string,
  defaultAutoClose: number,
  options?: ToastOptions
): Id {
  const autoClose =
    options?.autoClose !== undefined ? options.autoClose : defaultAutoClose;

  const toastOptions: ToastOptions = {
    ...shared,
    autoClose,
    ...options,
  };

  const text = translateApiMessage(message);
  let id: Id;

  switch (type) {
    case 'success':
      id = toast.success(text, toastOptions);
      break;
    case 'error':
      id = toast.error(text, toastOptions);
      break;
    case 'warn':
      id = toast.warn(text, toastOptions);
      break;
    case 'info':
      id = toast.info(text, toastOptions);
      break;
  }

  scheduleDismiss(id, toastOptions.autoClose);
  return id;
}

export const appToast = {
  success(message: string, options?: ToastOptions) {
    return showToast('success', message, 2000, options);
  },
  error(message: string, options?: ToastOptions) {
    return showToast('error', message, 3000, options);
  },
  warn(message: string, options?: ToastOptions) {
    return showToast('warn', message, 4000, options);
  },
  info(message: string, options?: ToastOptions) {
    return showToast('info', message, 2500, options);
  },
};
